import {
  DOWNLOAD_LEGAL_DOCUMENTS,
  DOWNLOAD_LEGAL_DOCUMENTS_SUCCESS,
  DOWNLOAD_LEGAL_DOCUMENTS_ERROR,
  GET_SELLER_LEGAL_DOCUMENTS,
  GET_SELLER_LEGAL_DOCUMENTS_ERROR,
  GET_SELLER_LEGAL_DOCUMENTS_SUCCESS
} from './LegalDocumentationSection.actions'

const legalDocumentsState = {
  currentDownload: {},
  documents: [],
  downloadedFiles: {},
  downloading: false,
  error: false,
  file: null,
  loading: true
}

/**
 * The seller legal documents section's reducer.
 */
const legalDocumentsReducer = (state = legalDocumentsState, { payload, type }) => {
  switch (type) {
    case GET_SELLER_LEGAL_DOCUMENTS: {
      return { ...state, loading: true }
    }
    case GET_SELLER_LEGAL_DOCUMENTS_ERROR: {
      return { ...state, error: true, loading: false }
    }
    case GET_SELLER_LEGAL_DOCUMENTS_SUCCESS: {
      return {
        ...state,
        documents: payload.documents,
        loading: false
      }
    }
    case DOWNLOAD_LEGAL_DOCUMENTS: {
      return {
        ...state,
        currentDownload: payload,
        downloading: true
      }
    }
    case DOWNLOAD_LEGAL_DOCUMENTS_SUCCESS: {
      return {
        ...state,
        downloading: false,
        currentDownload: {
          ...state.currentDownload,
          [payload.code]: false
        },
        downloadedFiles: payload.downloadedFiles
      }
    }
    case DOWNLOAD_LEGAL_DOCUMENTS_ERROR: {
      return {
        ...state,
        downloading: false,
        currentDownload: {
          ...state.currentDownload,
          [payload.code]: false
        },
        downloadingError: payload.error
      }
    }
    default: {
      return state
    }
  }
}

export default legalDocumentsReducer
